import { PopupMap } from "./PopupMap";
import { usePopupNotification } from "./PopupNotificationProvider";

export const PopupNotification = () => {
  const { isOpen, childrenElement } = usePopupNotification();

  if (!isOpen) {
    return null;
  }

  return <PopupMap>{childrenElement}</PopupMap>;
};
